import styled from 'styled-components'

export const Field = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 13rem 34rem;
  grid-template-rows: 2.4rem 5rem;
  gap: 2rem 3rem;
  grid-template-areas:
    '. title'
    'info input';

  @media (max-width: 1279px) {
    grid-template-columns: 13rem 1fr;
  }

  @media (max-width: 999px) {
    grid-template-columns: 13rem 1fr;
  }

  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
  }
`

export const Title = styled.h4`
  font-family: Navigo, Arial, Helvetica, sans-serif;
  font-size: 1.6rem;
  line-height: 2.4rem;
  font-weight: 400;
  color: #292e3d;
  grid-area: title;
  margin: 0;

  @media (max-width: 767px) {
    margin-bottom: 1.5rem;
  }
`

export const Info = styled.div`
  grid-area: info;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  p {
    font-family: Navigo, Arial, Helvetica, sans-serif;
    font-size: 1.6rem;
    line-height: 2.4rem;
    font-weight: 400;
    color: #292e3d;
  }

  div[class^='TooltipNewstyled'] {
    font-size: 1.2rem;
    line-height: 1.8rem;
    color: #292e3d;
    font-weight: 400;
    p {
      font-size: 1.2rem;
      line-height: 1.8rem;
      color: #292e3d;
      font-weight: 400;
      margin: 0;
      &:not(:last-child) {
        margin-bottom: 1rem;
      }
    }
    ul {
      padding-left: 2rem;
    }
    li {
      position: relative;
      &:after {
        content: '';
        display: block;
        position: absolute;
        left: -11px;
        width: 3px;
        height: 3px;
        top: 8px;
        border-radius: 50%;
        background-color: #292e3d;
      }

      &:not(:last-child) {
        margin-bottom: 3px;
      }
    }
  }

  @media (max-width: 767px) {
    margin-bottom: 2rem;
  }
`

export const InputItem = styled.div`
  grid-area: input;

  @media (max-width: 767px) {
    width: 100%;
  }
`

export const TooltipNew = styled.div`
  position: relative;
  top: 2px;
`
